/**
 * Memória da aba do navegador. As páginas do montador desmontam ao trocar de
 * menu (e as abas do Radix também), então o que o usuário fez precisa morar
 * fora do React para sobreviver à ida e volta. `sessionStorage` pode estar
 * bloqueado (janela privada, política do navegador) — nesse caso só não lembra.
 */

export function lerSessao<T>(chave: string): T | null {
  try {
    const bruto = sessionStorage.getItem(chave);
    return bruto === null ? null : (JSON.parse(bruto) as T);
  } catch {
    return null;
  }
}

export function gravarSessao(chave: string, valor: unknown) {
  try {
    sessionStorage.setItem(chave, JSON.stringify(valor));
  } catch {
    /* sem armazenamento: segue só em memória */
  }
}

export function apagarSessao(chave: string) {
  try {
    sessionStorage.removeItem(chave);
  } catch {
    /* idem */
  }
}
